export const LAYOUT_CONSTANTS = {
  NAVBAR_HEIGHT: 65,
  SIDEBAR: {
    DEFAULT_WIDTH: 350,
    MIN_WIDTH: 300,
    MAX_WIDTH: 600,
    TOGGLE_BUTTON_OFFSET: 60,
    TOGGLE_BUTTON_DEFAULT_LEFT: 16,
  },
  TRANSITIONS: {
    DURATION: '0.3s',
  },
};

export const AUTH_PAGES = [
  '/login',
  '/sign-up',
  '/landingpage',
  '/resetpassword',
  '/privacypolicy',
  '/terms-conditions',
  '/get-started',
  '/about',
  '/contactus',
  '/pricing',
];
